<template>
  <v-card v-if="log" class="wl-detail">
    <div class="wl-detail-head">
      <v-icon class="mr-2" color="white">mdi-file-search-outline</v-icon>
      <span>Détail du log</span>
      <v-spacer></v-spacer>
      <v-chip
        v-if="log.niveau"
        size="small"
        :style="{ backgroundColor: levelColor(log.niveau), color: 'white', fontWeight: 700 }"
      >
        {{ log.niveau }}
      </v-chip>
    </div>

    <div class="wl-detail-body">
      <v-table density="compact" class="wl-detail-table">
        <tbody>
          <tr v-if="log.horodatage">
            <td>Date</td>
            <td>{{ formatTs(log.horodatage) }}</td>
          </tr>
          <tr v-if="log.statut">
            <td>Statut</td>
            <td>
              <v-chip size="small" :style="{ backgroundColor: statutColor(log.statut), color: 'white', fontWeight: 700 }">
                {{ log.statut }}
              </v-chip>
            </td>
          </tr>
          <tr v-if="log.request">
            <td>Requête</td>
            <td class="wl-mono">{{ log.request }}</td>
          </tr>
          <tr v-if="log.path">
            <td>Path</td>
            <td class="wl-mono">{{ log.path }}</td>
          </tr>
          <tr v-if="log.client">
            <td>Client</td>
            <td>{{ log.client }}</td>
          </tr>
          <tr v-if="log.user">
            <td>User</td>
            <td>{{ log.user }}</td>
          </tr>
          <tr v-if="log.duree_ms">
            <td>Durée</td>
            <td>{{ log.duree_ms }} ms</td>
          </tr>
          <tr v-if="log.code_fm">
            <td>Code FM</td>
            <td>{{ log.code_fm }}</td>
          </tr>
          <tr v-if="log.id_correlation">
            <td>ID corrélation</td>
            <td class="wl-mono">{{ log.id_correlation }}</td>
          </tr>
          <tr v-if="log.cree_par">
            <td>Créé par</td>
            <td>{{ log.cree_par }}</td>
          </tr>
        </tbody>
      </v-table>

      <!-- Message d'erreur -->
      <div v-if="log.erreur_message" class="wl-block wl-block-error">
        <div class="wl-block-label">Message d'erreur</div>
        <pre class="wl-pre">{{ log.erreur_message }}</pre>
      </div>

      <!-- Body -->
      <div v-if="log.body" class="wl-block">
        <div class="wl-block-label">Body</div>
        <pre class="wl-pre">{{ pretty(log.body) }}</pre>
      </div>

      <!-- Response -->
      <div v-if="log.response" class="wl-block">
        <div class="wl-block-label">Response</div>
        <pre class="wl-pre">{{ pretty(log.response) }}</pre>
      </div>
    </div>

    <div class="wl-detail-foot">
      <v-btn variant="flat" color="#EF5350" style="color:white" @click="$emit('close')">
        Fermer
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    log: { type: Object, default: null },
    levelColor: { type: Function, default: () => "#90A4AE" },
    statutColor: { type: Function, default: () => "#90A4AE" },
    formatTs: { type: Function, default: (v) => v },
  },
  emits: ["close"],
  methods: {
    // Tente d'indenter joliment le JSON ; sinon renvoie le texte brut.
    pretty(value) {
      if (value === undefined || value === null) return "";
      if (typeof value === "object") {
        try { return JSON.stringify(value, null, 2); } catch (e) { return String(value); }
      }
      const str = String(value);
      try {
        const parsed = JSON.parse(str);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return str;
      }
    },
  },
};
</script>

<style>
@import "../style.css";
</style>
